<template>
  <div
    class="flex items-center border border-gray-300 rounded"
    :class="
      'w-' + displayWidth + ' ' + 'py-' + paddingY + ' ' + 'px-' + paddingX
    "
  >
    <div
      class="flex items-center justify-between border-1.5 px-3 py-0.5 rounded gap-4 w-full"
    >
      <div
        @click="
          openPDFViewer(
            document.url,
            document.document?.Description,
            document.document
          )
        "
        class="cursor-pointer flex"
      >
        <!-- Document Icon -->
        <div class="mr-2">
          <img
            src="@/assets/icons/pdf.png"
            alt="Document Icon"
            class="w-6 h-6"
            v-if="fileType === 'pdf'"
          />
          <img
            src="@/assets/icons/word.png"
            alt="Document Icon"
            class="w-6 h-6"
            v-if="fileType === 'doc' || fileType === 'docx'"
          />
          <img
            src="@/assets/icons/excel.png"
            alt="Document Icon"
            class="w-6 h-6"
            v-if="fileType === 'xls' || fileType === 'xlsx'"
          />
          <img
            src="@/assets/icons/powerpoint.png"
            alt="Document Icon"
            class="w-6 h-6"
            v-if="fileType === 'ppt' || fileType === 'pptx'"
          />
          <img
            src="@/assets/icons/png.png"
            alt="Document Icon"
            class="w-6 h-6"
            v-if="fileType === 'png'"
          />
          <img
            src="@/assets/icons/jpeg.png"
            alt="Document Icon"
            class="w-6 h-6"
            v-if="fileType === 'jpg' || fileType === 'jpeg'"
          />
        </div>

        <!-- Document Name -->
        <div class="flex-grow truncate">
          <p style="font-size: 0.8rem !important" class="overflow-ellipsis">
            {{ document.DocumentType }}
          </p>
        </div>
      </div>

      <!-- Delete Icon -->
      <div
        class="cursor-pointer"
        @mouseover="toggleDeleteIcon = true"
        @mouseout="toggleDeleteIcon = false"
        v-if="showDeleteIcon"
      >
        <el-popover placement="top" width="200" v-model="visible">
          <p style="font-size: 0.7rem !important">
            Do you want to delete this file?
          </p>

          <div
            style="
              text-align: right;
              margin: 1rem 0;
              font-size: 0.8rem !important;
            "
          >
            <el-button
              size="mini"
              @click="visible = false"
              style="padding: 0.3rem 0rem; font-size: 0.7rem !important"
              >Cancel</el-button
            >
            <el-button
              type="warning"
              size="mini"
              @click="deleteDocument(document)"
              style="padding: 0.3rem 0rem; font-size: 0.7rem !important"
              >Delete</el-button
            >
          </div>

          <el-button type="text" slot="reference" style="padding: 0 !important">
            <img
              v-if="!toggleDeleteIcon"
              class="h-4 object-contain cursor-pointer"
              src="@/assets/icons/delete.png"
            />
            <img
              v-else
              class="h-4 object-contain cursor-pointer"
              src="@/assets/icons/recycle-bin.png"
            />
          </el-button>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DocumentDisplay',
  props: {
    document: Object,
    deleteDocumentCallback: Function,
    openPDFViewer: Function,
    showDeleteIcon: Boolean,
    displayWidth: Number,
    paddingX: Number,
    paddingY: Number,
  },
  data() {
    return {
      toggleDeleteIcon: false,
      showDeletePopover: false,
      visible: false,
      fileType: '',
    };
  },
  created() {
    this.getIconForFileType();
  },
  methods: {
    getIconForFileType() {
      this.fileType =
        this.document.url.split('.')[this.document.url.split('.').length - 1];
    },
    deleteDocument() {
      this.visible = false;
      this.deleteDocumentCallback(this.document);
      this.showDeletePopover = false;
    },

    open() {
      this.$confirm(
        'This will permanently delete the file. Continue?',
        'Warning',
        {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }
      )
        .then(() => {
          this.$message({
            type: 'success',
            message: 'Delete completed',
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: 'Delete canceled',
          });
        });
    },
  },
};
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
